import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable @typescript-eslint/no-misused-promises */
import { AppMode, Zipcode } from '@chegg/payment-methods';
import { savePaymentMethodsCommands } from '../../redux/command/command.slice';
import { executeDropInPaymentsCommands } from '../../redux/command/command.action';
import { Environment, fireLogEvent, fireStatusUpdate, Namespace, PaymentMethodsCommandNames, DropInPaymentsCommandNames, SharedCommandNames, StatusTypes, Component, CallbackTypes, UserAddressCommandNames, getRecurlyPreviewPurchase, getRecurlyCart } from '@chegg/commerce-utils';
import { saveReviewData } from '../../redux/review/review.slice';
import { saveUiConfigs } from '../../redux/config/config.slice';
import { saveAppMode } from '../../redux/appMode/appMode.slice';
import { isOrderPreviewCountry } from '../OrderPreviewWrapper/helpers';
import { saveCartInfo } from '../../redux/cart/cart.slice';
import { sendNewRelicMessage } from '../../utils/NewRelicUtils';
import { REVIEW_STEP } from './DropInPayments';
var reviewStep = 1;

/**
 * Update reviewStep
 * @param currentStep
 */
export var updateReviewStep = function updateReviewStep(currentStep) {
  // need this since dip does not re-render in review step
  reviewStep = currentStep;
};
/**
 * Consume status updates passed back from DropInPayments and call actions based on status
 * @param statusUpdates an array of status updates
 * @param dispatch
 * @param review
 */
export var consumeStatusUpdates = function consumeStatusUpdates(_ref) {
  var statusUpdates = _ref.statusUpdates,
    dispatch = _ref.dispatch,
    review = _ref.review,
    config = _ref.config,
    apolloClient = _ref.apolloClient,
    cart = _ref.cart;
  var passthroughPayloads = [];
  statusUpdates.forEach( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(update) {
      var _cart$billingCountry;
      var status, command, payload, component, data, isRecurly, recurlyCart, uuid, couponCode, externalId, items, billingCountry, updateRecurlyCart, postalCode, zip, shouldSkipPostalCode, _postalCode, countryCode, _postalCode2, _countryCode, billingAddress, isReview, errors, currency, _postalCode3, previewPurchase, _recurlyCart2;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            status = update.status, command = update.command, payload = update.payload;
            component = payload.component, data = payload.data;
            isRecurly = config.isRecurly, recurlyCart = config.recurlyCart, uuid = config.userUuid, couponCode = config.couponCode;
            externalId = cart.externalId, items = cart.items;
            billingCountry = (_cart$billingCountry = cart.billingCountry) !== null && _cart$billingCountry !== void 0 ? _cart$billingCountry : config.country;
            updateRecurlyCart = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
                var countryCode, postalCode, currency, previewPurchase, _recurlyCart, orderSummary;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      countryCode = _ref3.countryCode, postalCode = _ref3.postalCode;
                      currency = recurlyCart === null || recurlyCart === void 0 ? void 0 : recurlyCart.orderSummary.currencyName;
                      if (!(externalId && uuid && currency && apolloClient)) {
                        _context.next = 8;
                        break;
                      }
                      _context.next = 5;
                      return getRecurlyPreviewPurchase({
                        externalId: externalId,
                        currency: currency,
                        countryCode: countryCode,
                        postalCode: postalCode,
                        uuid: uuid,
                        apolloClient: apolloClient,
                        couponCode: couponCode
                      });
                    case 5:
                      previewPurchase = _context.sent;
                      _recurlyCart = getRecurlyCart({
                        previewPurchase: previewPurchase,
                        cartItems: items,
                        externalId: externalId,
                        currency: currency
                      });
                      if (_recurlyCart) {
                        orderSummary = _recurlyCart.orderSummary;
                        dispatch(saveCartInfo({
                          taxInfo: {
                            totalWithTax: orderSummary.total,
                            tax: orderSummary.tax,
                            priceTotalWithTaxCurrency: orderSummary.totalWithCurrencyFormat,
                            taxTotalWithCurrency: orderSummary.taxWithCurrencyFormat,
                            taxDetails: []
                          },
                          orderSummary: orderSummary
                        }));
                      }
                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function updateRecurlyCart(_x2) {
                return _ref4.apply(this, arguments);
              };
            }();
            if (command === UserAddressCommandNames.UA_PROGRESS_STATUS && status === StatusTypes.SUCCESS && isRecurly) {
              postalCode = data === null || data === void 0 ? void 0 : data.zipcode;
              updateRecurlyCart({
                postalCode: postalCode,
                countryCode: billingCountry
              });
            } else if (command === PaymentMethodsCommandNames.MOP_SELECTED && status === StatusTypes.SUCCESS && isRecurly) {
              zip = (data === null || data === void 0 ? void 0 : data.billingAddress).zip;
              shouldSkipPostalCode = zip === Zipcode.ABCDE || zip === Zipcode.GB;
              _postalCode = shouldSkipPostalCode ? undefined : zip;
              countryCode = (data === null || data === void 0 ? void 0 : data.billingAddress).country;
              updateRecurlyCart({
                postalCode: _postalCode,
                countryCode: countryCode
              });
            } else if (command === UserAddressCommandNames.ADDRESS_UPDATE && status === StatusTypes.SUCCESS) {
              _postalCode2 = (data === null || data === void 0 ? void 0 : data.zip).value || undefined;
              _countryCode = (data === null || data === void 0 ? void 0 : data.country).countryCode;
              if (_countryCode && _countryCode !== billingCountry) {
                saveCartInfo({
                  billingCountry: _countryCode
                });
                updateRecurlyCart({
                  postalCode: _postalCode2,
                  countryCode: _countryCode
                });
              }
            }
            if (!(command == SharedCommandNames.INITIALIZE && status == StatusTypes.ERROR)) {
              _context2.next = 12;
              break;
            }
            dispatch(saveUiConfigs({
              paymentMethodsRenderFailed: true
            }));
            fireStatusUpdate([update], Namespace.DROP_IN_PAYMENTS);
            _context2.next = 44;
            break;
          case 12:
            if (!(command === PaymentMethodsCommandNames.MOP_SELECTED && status === StatusTypes.SUCCESS && review !== null && review !== void 0 && review.reviewStepEnabled)) {
              _context2.next = 17;
              break;
            }
            dispatch(saveReviewData({
              currentStep: 1,
              selectedMop: data.mop
            }));
            passthroughPayloads.push(update);
            _context2.next = 44;
            break;
          case 17:
            if (!(command === PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD)) {
              _context2.next = 30;
              break;
            }
            _context2.t0 = status;
            _context2.next = _context2.t0 === StatusTypes.SUCCESS ? 21 : _context2.t0 === StatusTypes.ERROR ? 23 : 28;
            break;
          case 21:
            if (review && review.reviewStepEnabled && reviewStep === 1) {
              dispatch(savePaymentMethodsCommands([{
                commandName: PaymentMethodsCommandNames.SELECTED_MOP_VIEW
              }]));
              dispatch(saveReviewData({
                currentStep: 2,
                selectedMop: data.mop
              }));
              fireStatusUpdate([{
                status: StatusTypes.SUCCESS,
                command: DropInPaymentsCommandNames.REVIEW_VIEW,
                payload: {}
              }], Namespace.DROP_IN_PAYMENTS);
            } else {
              if (data && data.tokenId && data.billingAddress) {
                // for Recurly new user with no mop and wallet PM user (ex. PayPal), persist the tokenId so it can be used to create purchase
                dispatch(saveCartInfo({
                  tokenId: data.tokenId,
                  billingAddress: data.billingAddress
                }));
              } else if (data && data.mop && data.mop.isRecurly && data.mop.cardId) {
                // for Recurly user with existing mop, billingInfoId and billingAddress data are transformed to PaymentMethodsData
                // these need to transform back to MopDetails for create purchase mutation
                billingAddress = data.mop.billingAddress;
                dispatch(saveCartInfo({
                  billingInfoId: data.mop.cardId,
                  billingAddress: {
                    addressLine1: billingAddress.line1,
                    addressLine2: billingAddress.line2,
                    city: billingAddress.city,
                    country: billingAddress.country,
                    phone: billingAddress.phone,
                    postalCode: billingAddress.zip,
                    state: billingAddress.state
                  }
                }));
              } else {
                // for Braintree
                dispatch(executeDropInPaymentsCommands([{
                  commandName: DropInPaymentsCommandNames.PLACE_ORDER_THROUGH_SDK,
                  data: data //TODO: this interface is wrong in PM
                }]));
              }
            }
            return _context2.abrupt("break", 28);
          case 23:
            // eslint-disable-next-line no-case-declarations
            isReview = review && review.reviewStepEnabled; // eslint-disable-next-line no-case-declarations
            errors = payload.errors;
            fireStatusUpdate([{
              status: status,
              command: isReview ? DropInPaymentsCommandNames.REVIEW_VIEW : DropInPaymentsCommandNames.PLACE_ORDER,
              payload: {
                component: component,
                errors: errors
              }
            }], Namespace.DROP_IN_PAYMENTS);
            dispatch(saveCartInfo({
              isCheckoutPending: false
            }));
            return _context2.abrupt("break", 28);
          case 28:
            _context2.next = 44;
            break;
          case 30:
            if (!(command == PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD_ENABLED)) {
              _context2.next = 43;
              break;
            }
            if (!(data !== null && data !== void 0 && data.country)) {
              _context2.next = 40;
              break;
            }
            currency = recurlyCart === null || recurlyCart === void 0 ? void 0 : recurlyCart.orderSummary.currencyName;
            _postalCode3 = data.billingAddress.zip || '';
            if (!(externalId && uuid && currency && apolloClient)) {
              _context2.next = 40;
              break;
            }
            _context2.next = 37;
            return getRecurlyPreviewPurchase({
              externalId: externalId,
              currency: currency,
              countryCode: billingCountry,
              postalCode: _postalCode3,
              uuid: uuid,
              apolloClient: apolloClient,
              couponCode: couponCode
            });
          case 37:
            previewPurchase = _context2.sent;
            _recurlyCart2 = getRecurlyCart({
              previewPurchase: previewPurchase,
              cartItems: items,
              externalId: externalId,
              currency: currency
            });
            dispatch(saveCartInfo({
              taxInfo: {
                totalWithTax: _recurlyCart2 === null || _recurlyCart2 === void 0 ? void 0 : _recurlyCart2.orderSummary.total,
                tax: _recurlyCart2 === null || _recurlyCart2 === void 0 ? void 0 : _recurlyCart2.orderSummary.tax,
                priceTotalWithTaxCurrency: _recurlyCart2 === null || _recurlyCart2 === void 0 ? void 0 : _recurlyCart2.orderSummary.totalWithCurrencyFormat,
                taxTotalWithCurrency: _recurlyCart2 === null || _recurlyCart2 === void 0 ? void 0 : _recurlyCart2.orderSummary.taxWithCurrencyFormat,
                taxDetails: []
              },
              orderSummary: _recurlyCart2 === null || _recurlyCart2 === void 0 ? void 0 : _recurlyCart2.orderSummary
            }));
          case 40:
            fireStatusUpdate([{
              status: status,
              command: DropInPaymentsCommandNames.PLACE_ORDER_ENABLED,
              payload: {
                component: Component.PAYMENT_METHODS_CALLBACK
              }
            }], Namespace.DROP_IN_PAYMENTS);
            _context2.next = 44;
            break;
          case 43:
            if (command === PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD_DISABLED) {
              fireStatusUpdate([{
                status: status,
                command: DropInPaymentsCommandNames.PLACE_ORDER_DISABLED,
                payload: {
                  component: Component.PAYMENT_METHODS_CALLBACK
                }
              }], Namespace.DROP_IN_PAYMENTS);
            } else if (command === SharedCommandNames.APP_MODE_CHANGED) {
              dispatch(saveAppMode({
                appModeName: data === null || data === void 0 ? void 0 : data.appMode
              }));
              if ((data === null || data === void 0 ? void 0 : data.appMode) === AppMode.ADD || (data === null || data === void 0 ? void 0 : data.appMode) === AppMode.EDIT) {
                dispatch(saveReviewData({
                  currentStep: 1
                }));
              }
              fireStatusUpdate([{
                status: status,
                command: SharedCommandNames.APP_MODE_CHANGED,
                payload: {
                  data: {
                    appMode: data === null || data === void 0 ? void 0 : data.appMode
                  }
                }
              }], Namespace.DROP_IN_PAYMENTS);
            } else if (command === DropInPaymentsCommandNames.BILLDESK_RESPONSE_HANDLER && status !== StatusTypes.ERROR) {
              dispatch(executeDropInPaymentsCommands([{
                commandName: DropInPaymentsCommandNames.BILLDESK_RESPONSE_HANDLER,
                data: {
                  status: data === null || data === void 0 ? void 0 : data.status,
                  message: data === null || data === void 0 ? void 0 : data.message
                }
              }]));
            } else {
              //if we don't know what to do with the status update, just pass it to the host.
              passthroughPayloads.push(update);
            }
          case 44:
            if (passthroughPayloads.length > 0) {
              fireStatusUpdate(passthroughPayloads, Namespace.DROP_IN_PAYMENTS);
            }
          case 45:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
};
export var callback = function callback(_ref5) {
  var response = _ref5.response,
    dispatch = _ref5.dispatch,
    review = _ref5.review,
    config = _ref5.config,
    apolloClient = _ref5.apolloClient,
    cart = _ref5.cart;
  switch (response.callbackType) {
    case CallbackTypes.LOG_EVENT:
      //just bubble up log events
      fireLogEvent(response.data, Namespace.DROP_IN_PAYMENTS);
      break;
    case CallbackTypes.STATUS_UPDATE:
      consumeStatusUpdates({
        statusUpdates: response.data,
        dispatch: dispatch,
        review: review,
        config: config,
        apolloClient: apolloClient,
        cart: cart
      });
      break;
    default:
      sendNewRelicMessage("Unrecognized callbackType: ".concat(response.callbackType));
  }
};

/**
 * Get current environment based on cheggBaseUrl
 * @param cheggBaseUrl
 * Returns current environment
 */
export var assignEnv = function assignEnv(cheggBaseUrl) {
  if (cheggBaseUrl && cheggBaseUrl.includes('www.chegg.com')) {
    return Environment.PRODUCTION;
  }
  return Environment.DEVELOPMENT;
};

/**
 * Execute ReviewView command
 * @param dispatch
 */
export var executeReviewView = function executeReviewView(dispatch) {
  dispatch(executeDropInPaymentsCommands([{
    commandName: DropInPaymentsCommandNames.REVIEW_VIEW
  }]));
};

/**
 * Check if order preview should be shown
 */
export var showOrderPreview = function showOrderPreview(params) {
  return params.cartItems.length > 0 && params.currentStep !== REVIEW_STEP && isOrderPreviewCountry(params.country) && (params.displayOrderSummary || params.appMode !== AppMode.ADD && params.appMode !== AppMode.EDIT);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/DropInPayments/helper.js
// module id = 1517
// module chunks = 11